import { IconCheck } from '@tabler/icons-react'

interface BenefitsListProps {
  title: string
  benefits: Array<string>
}

export function BenefitsList({ title, benefits }: BenefitsListProps) {
  return (
    <div className="space-y-3">
      <p className="text-sm font-semibold">{title}</p>
      <div className="bg-muted/30 rounded-md p-4">
        {/* No max-height here on purpose: capping it produced a scrollbar
            nested inside a dialog that already scrolls, and the cap fitted
            exactly seven single-line items — one wrapped line, a longer
            translation or a narrow viewport brought the nested scroll back.
            The dialog's own max-h-[90vh] handles the extreme case. */}
        <ul className="space-y-2.5">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start gap-2 text-sm">
              <IconCheck className="mt-0.5 h-4 w-4 shrink-0 text-green-600 dark:text-green-400" />
              <span className="text-muted-foreground">{benefit}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
